var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlacklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0;\n      }\n\n      .cls-2 {\n        fill: #204bf8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(-5655 -1081)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4744",
    "data-name": "Rectangle 4744",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(5655 1081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-ban",
    "data-name": "Icon open-ban",
    className: "cls-2",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Zm0,3a8.978,8.978,0,0,1,5.25,1.68L4.68,17.25A9.01,9.01,0,0,1,12,3Zm7.32,3.75A9.01,9.01,0,0,1,6.75,19.32Z",
    transform: "translate(5655 1081)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklist);
export default __webpack_public_path__ + "static/media/blacklist.cde7430f98221d307b1800459cd7a3cf.svg";
export { ForwardRef as ReactComponent };